module.exports = __webpack_public_path__ + "img/mandil_1.d87727dc.png";